import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../core/services/config/config.service';
import { UsState } from '../../models/state';
import { UtilityService } from '../utility/utility.service';

@Injectable({
  providedIn: 'root',
})
export class UsStatesService {
  private utilityService = inject(UtilityService);
  private configService = inject(ConfigService);
  private config = this.configService.config;

  usStatesEndpoint = this.config.patientApiUrl + '/v1/Admin/States';

  getUsStates(): Observable<UsState[]> {
    return this.utilityService.getRequest<UsState[]>(this.usStatesEndpoint);
  }
}
